// 销售单状态码 → 主状态文案的 i18n key 映射。
// 商城订单与销售单的状态码存在重叠，调用方必须按业务域选用对应映射。
export const TRADE_STATUS_MAIN_KEY_MAP = {
	0: 'trade.tradelist.465643-37', // 未转入销售单的网店订单
	1000: 'trade.tradelist.465643-67', // 排队处理中
	1010: 'trade.tradelist.465643-39', // 待审核
	1020: 'common.FloatLoginAndApplyTips.788548-6', // 审核中
	1030: 'home.home.336045-2', // 预售
	1050: 'trade.tradelist.465643-40', // 待复核
	1051: 'trade.tradelist.465643-41', // 复核中
	2000: 'trade.tradelist.465643-42', // 备货等待
	2010: 'trade.tradelist.465643-42', // 备货等待
	2020: 'trade.tradelist.465643-44', // 服务等待
	2030: 'trade.tradelist.465643-42', // 备货等待
	2040: 'trade.tradelist.465643-46', // 采购等待
	3010: 'trade.tradelist.465643-47', // 虚拟发货
	4110: 'trade.TradeItem.383848-5', // 待发货
	4111: 'trade.TradeItem.383848-5', // 待发货
	4112: 'trade.TradeItem.383848-5', // 待发货
	4113: 'trade.TradeItem.383848-5', // 待发货
	4114: 'trade.TradeItem.383848-5', // 待发货
	4121: 'trade.TradeItem.383848-5', // 待发货
	4122: 'trade.TradeItem.383848-5', // 待发货
	4123: 'trade.TradeItem.383848-5', // 待发货
	4130: 'trade.tradelist.465643-56', // 部分发货
	4040: 'trade.TradeItem.383848-5', // 代销发货→待发货
	4041: 'trade.TradeItem.383848-5', // 代销发货→待发货
	4042: 'trade.TradeItem.383848-5', // 代销发货→待发货
	4050: 'trade.tradelist.465643-68', // 门店发货
	4051: 'trade.tradelist.465643-68', // 门店发货
	4052: 'trade.tradelist.465643-68', // 门店发货
	5010: 'trade.tradelist.465643-63', // 已取消
	5020: 'trade.TradeItem.383848-3', // 原始单-被合并
	5030: 'trade.TradeItem.383848-4', // 原始单-被拆分
	6000: 'trade.tradelist.465643-66', // 发货在途
	9090: 'trade.tradelist.465643-30', // 已完成
};
